import { PublicAuthToken, ScopeDefinition } from '@api/shared-types/PublicAuthToken';
import { hasOwnPropertyTS } from '@utils/typescriptGuards';



export function isPublicAuthToken(obj: unknown): obj is PublicAuthToken {
	if (obj !== undefined
		&& obj !== null
		
		&& hasOwnPropertyTS(obj, 'scope') && Array.isArray(obj['scope'])
		&& obj['scope'].length > 0 && obj['scope'].every(x => isScopeDefinition(x))
		
		&& hasOwnPropertyTS(obj, 'userId') && obj['userId']
		&& typeof obj['userId'] === 'string' && obj['userId'].length > 0
		
		&& hasOwnPropertyTS(obj, 'userName') && obj['userName']
		&& typeof obj['userName'] === 'string' && obj['userName'].length > 0
		
		&& hasOwnPropertyTS(obj, 'validTo') && obj['validTo']
		&& typeof obj['validTo'] === 'string' && obj['validTo'].length > 0

		&& hasOwnPropertyTS(obj, 'token') && obj['token']
		&& typeof obj['token'] === 'string' && obj['token'].length > 0)
		return true;
	return false;
}


export function isScopeDefinition(obj: unknown): obj is ScopeDefinition {
	if (obj !== undefined
		&& obj !== null
		
		&& hasOwnPropertyTS(obj, 'roles') && Array.isArray(obj['roles'])
		
		&& hasOwnPropertyTS(obj, 'app') && obj['app']
		&& typeof obj['app'] === 'string' && obj['app'].length > 0)
		return true;
	return false;
}


export function isStorageEvent(event: Event): event is StorageEvent {
	if (event !== undefined
		&& event !== null
		&& 'key' in event
		&& 'newValue' in event
		&& 'oldValue' in event)
		return true;
	return false;
}


export function isStorageClear(event: Event): boolean {
	if (event !== undefined
		&& event !== null
		&& 'key' in event && event.key === null
		&& 'newValue' in event && event.newValue === null
		&& 'oldValue' in event && event.oldValue === null)
		return true;
	return false;
}